import { Button, Card, DatePicker, Form, Icon, Input, message, Select, Spin, TimePicker } from 'antd';
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import DocumentList from "../../components/DocumentList";
import moment from "moment";
import MasterModal from "../../components/MasterModal";
import "./style.css";

class Create extends React.Component {
  constructor() {
    super();
    this.addMaintenance = this.addMaintenance.bind(this);
    this.id = 0;
    this.state = {
      showJobsCardNumber: [],
      keys: [],
      jobCardStatus: {},
      timeFrom: [null],
      timeTo: [null],
      total: 0,
      documentData: [],
      selectedManpowerHours: Number.MAX_VALUE,
      allowEntryOfManpowerWithoutMinimumTimeLimitCompleted: false,
      currentActivityEnabled: {},
    };
  }

  componentDidMount() {
    const { match, location, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }

    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.roles.length > 0) {
      for (const role of user.roles) {
        if (role && role.allowEntryOfManpowerWithoutMinimumTimeLimitCompleted) {
          this.setState({
            allowEntryOfManpowerWithoutMinimumTimeLimitCompleted: true,
          });
          break;
        }
      }
    }

    const data = [{}];
    this.setState({
      keys: data,
    });
  }

  // A maintenance row is "locked" only when it was SAVED as a Job Card type, has an
  // activity linked, AND that activity's Job Card is already CLOSED. Editing/removing a
  // row tied to a closed job card would cascade to the Activity's status on the backend
  // (see manpower-performance service update: activityStatus Open/Closed re-updates the
  // Activity), so those stay read-only and non-deletable. If the Job Card is still OPEN,
  // the row remains fully editable/removable. All non-Job-Card rows are always editable.
  // disableMaintenanceListByJobCard is keyed by the linked activity id (see
  // componentWillReceiveProps / getJobCardStatusByActivityId), so it stays correct even
  // after rows are re-indexed by a delete.
  isLockedRow = (k) => {
    if (this.props.title !== 'EDIT') {
      return false;
    }
    const savedIsJobCard =
      k && k.type && k.type.name && k.type.name.toLowerCase() === 'job card';
    const activityId = k && k.jobCardActivityNumber && k.jobCardActivityNumber._id;
    if (!(savedIsJobCard && activityId)) {
      return false;
    }
    const jobCardStatusByActivity = this.props.disableMaintenanceListByJobCard || {};
    return jobCardStatusByActivity[activityId] === 'Closed';
  };

  removeMaintenance = index => {
    const { keys, timeFrom, timeTo, jobCardStatus, showJobsCardNumber } = this.state;
    let { total } = this.state;
    const { form, filters } = this.props;
    const item = filters['maintenance'];

    // Safety guard: a locked row (Job Card that is already Closed) can never be removed.
    // The remove control is hidden for those rows; this just backstops it.
    if (this.isLockedRow(keys[index])) {
      return;
    }
    const val = form.getFieldValue('maintenance');
    const removedItem = val[index];
    if (removedItem.hour) {
      total = total - parseInt(removedItem.hour);
    }
    val.splice(index, 1);
    timeFrom.splice(index, 1);
    timeTo.splice(index, 1);
    keys.splice(index, 1);
    showJobsCardNumber.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm, index) => {
        form.setFieldsValue({
          [`maintenance[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }

    delete jobCardStatus[index];

    this.setState({
      keys: keys,
      timeFrom,
      timeTo,
      total,
      jobCardStatus,
      showJobsCardNumber,
    });
  };

  addMaintenance = () => {
    const { keys } = this.state;
    keys.push(`${'maintenance'}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  componentWillReceiveProps(nextProps, nextContext) {
    // Seed the running total (and per-row time state) from saved maintenance rows. Guarded on
    // nextProps.data.maintenance (not this.props.data) so it also fires on the FIRST EDIT load,
    // where data arrives via async fetch and this.props.data is still undefined - otherwise the
    // meter stays at 0h / "short of minimum" until the user touches a time picker.
    if (nextProps.data && nextProps.data.maintenance && JSON.stringify(nextProps.data.maintenance) !== JSON.stringify(this.props.data && this.props.data.maintenance)) {
      const showJobsCardNumber = [];
      let total = 0;
      const { timeFrom, timeTo } = this.state;
      nextProps.data.maintenance.map((item, index) => {
        total += parseInt(item.hour);
        timeFrom[index] = moment(item.timeFrom);
        timeTo[index] = moment(item.timeTo);
        let jobCardPresent = item.type && item.type && item.type.name && item.type.name.toLowerCase() === 'job card';
        if (jobCardPresent > 0) {
          showJobsCardNumber[index] = true;
        } else {
          showJobsCardNumber[index] = false;
        }
      });
      this.setState({ showJobsCardNumber, total: total });
    }
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      if (nextProps.title === 'EDIT') {
        let jobCards = {};
        let currentActivityEnabled = {};
        nextProps.data && nextProps.data.maintenance && nextProps.data.maintenance.map((item, index) => {
          // console.log(item);
          if (item.jobCardActivityNumber) {
            // Key by activity id (not row index) so the resulting job-card-status map
            // stays valid after maintenance rows are re-indexed by a delete.
            jobCards[item.jobCardActivityNumber._id] = item.jobCardActivityNumber._id;
            currentActivityEnabled[index] = item.activityStatus === item.jobCardActivityNumber.status;
          }
        });
        if (Object.keys(jobCards).length) {
          this.props.getJobCardStatusByActivityId(jobCards);
        }
        this.setState({ currentActivityEnabled });
      }
      const { filters, data } = nextProps;
      const selectedEmployee = filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data'].find(item => item._id === data.employee._id);
      this.setState({
        keys: nextProps.data.maintenance,
        selectedManpowerHours: selectedEmployee && selectedEmployee.minimumWorkHours,
      });
      nextProps.getJobCardByLocation(nextProps.data.location._id);
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  // Manpower record linked to the logged-in user (Manpower.userAccount). The /auth/user
  // response embeds it as `manpower`. Used to auto-fill Prepared/Received By on a new
  // (CREATE) entry. Returns undefined when the user has no linked manpower record.
  getLoggedInManpowerId = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      return (user && user.manpower && user.manpower._id) || undefined;
    } catch (e) {
      return undefined;
    }
  };

  // Minimum required work-minutes for an employee. Tries several sources and uses the
  // first that yields a numeric minimum, so it never falls open to 0 while a real minimum
  // exists (the earlier id-exact-match requirement could miss and drop through to 0):
  //   1. The selected employee from the master filter list (covers picking a new employee).
  //   2. The saved record's populated employee when it matches the selected id.
  //   3. The saved record's populated employee regardless (reliable on EDIT — always has
  //      minimumWorkHours even if the employee is missing from the filter list).
  //   4. The selectedManpowerHours state — last-resort fallback.
  hasNumericMin = (emp) =>
    emp && emp.minimumWorkHours !== undefined && emp.minimumWorkHours !== null
    && !isNaN(Number(emp.minimumWorkHours));

  getRequiredWorkMinutes = (employeeId) => {
    const { filters, data } = this.props;
    const list = (filters && filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data']) || [];
    const savedEmployee = data && data.employee;
    const candidates = [
      // EDIT: the saved record's employee minimumWorkHours is authoritative while the
      // employee is unchanged (or the selection isn't resolved yet).
      (savedEmployee && (!employeeId || savedEmployee._id === employeeId)) ? savedEmployee : null,
      // A different employee was picked on the form → read from the employee master list.
      list.find(item => item && item._id === employeeId),
      // Last-resort fallbacks.
      savedEmployee,
    ];
    const match = candidates.find(this.hasNumericMin);
    const minHours = match ? match.minimumWorkHours : this.state.selectedManpowerHours;
    return (Number(minHours) || 0) * 60;
  };

  // Total logged work-minutes for the currently visible maintenance rows. Trims to the
  // number of rendered rows (this.state.keys.length): rc-form retains values for removed
  // (unmounted) rows, and removeMaintenance only re-maps survivors into the leading
  // indices, so anything past keys.length is a stale leftover that must not be counted.
  getTotalWorkMinutes = () => {
    const rows = (this.props.form.getFieldValue('maintenance') || []).slice(0, this.state.keys.length);
    return rows.reduce((sum, m) => sum + (parseInt(m && m.hour, 10) || 0), 0);
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const data = Object.assign({}, values);
      // rc-form retains values for removed (unmounted) maintenance rows, and
      // removeMaintenance only re-maps survivors into the leading indices. Trim to the
      // number of visible rows so stale/duplicate rows are neither saved nor counted.
      data.maintenance = (Array.isArray(data.maintenance) ? data.maintenance : [])
        .slice(0, this.state.keys.length)
        .filter(Boolean);
      // Enforce the employee's minimum work-hours on BOTH create and update. Compute the
      // total from the trimmed rows and read the requirement from the employee master so
      // removing rows / insufficient hours is blocked on UPDATE too, not just via the
      // submit-button disabled state.
      const totalMinutes = data.maintenance.reduce(
        (sum, m) => sum + (parseInt(m && m.hour, 10) || 0),
        0
      );
      const requiredMinutes = this.getRequiredWorkMinutes(values.employee);
      if (!this.state.allowEntryOfManpowerWithoutMinimumTimeLimitCompleted && requiredMinutes > totalMinutes) {
        message.error(
          `Total work time must be at least ${requiredMinutes / 60} hour(s) for the selected employee.`
        );
        return;
      }
      const { documentData } = this.state;
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      if (match.params && match.params.id) {
        const jobCardIDForBackToJC = this.props.location.search.split('=')[1];
        this.props.onSubmit(data, match.params.id, jobCardIDForBackToJC);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  handleSelect(index, data) {
    let jobCardPresent = this.props.filters && this.props.filters['maintenance'] && this.props.filters['maintenance']['schema'] && this.props.filters['maintenance']['schema']['type'].data.data.filter(item => (item._id === data && item.name.toLowerCase() === 'job card')).length;
    const showJobsCardNumber = [...this.state.showJobsCardNumber];
    if (jobCardPresent > 0) {
      showJobsCardNumber[index] = true;
      return this.setState({ showJobsCardNumber });
    }
    showJobsCardNumber[index] = false;
    const { form } = this.props;
    form.setFieldsValue({
      [`maintenance[${index}]['jobCardActivityNumber']`]: null,
    });
    form.setFieldsValue({
      [`maintenance[${index}]['activityStatus']`]: null,
    });
    return this.setState({ showJobsCardNumber });
  }

  handleJobCardSelect(index, data) {

    const { jobCards, form } = this.props;
    let { jobCardStatus } = this.state;
    const jobCard = jobCards.length > 0 && jobCards.find(ele => ele._id === data);
    jobCardStatus[index] = jobCard && jobCard.status;
    form.setFieldsValue({
      [`maintenance[${index}]['activityStatus']`]: jobCard && jobCard.status,
    });

    this.setState({
      jobCardStatus
    });
  }

  handleActivityStatusSelect(index, data) {
    // console.log(data);
    let { currentActivityEnabled } = this.state;
    const jobCardActivityStatus = this.state.jobCardStatus[index];
    currentActivityEnabled[index] = jobCardActivityStatus === data;
    this.setState({
      currentActivityEnabled
    });

  }

  handleEmployeeSelect(e) {
    const { filters } = this.props;
    const data = filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data'].find(item => item._id === e);
    this.setState({ selectedManpowerHours: data.minimumWorkHours });
  }

  handleTimeFromSelect = (index, e) => {
    const { timeTo, timeFrom } = this.state;
    let { total } = this.state;
    const { form } = this.props;
    timeFrom[index] = e;
    const duration = (timeTo[index] && e && timeTo[index].diff(e, 'minutes')) || 0;
    const val = form.getFieldValue(`maintenance[${index}]['hour']`);
    total = total - ((val && parseInt(val)) || 0);
    total += ((duration && parseInt(duration)) || 0);
    this.setState({ timeFrom, total });
    form.setFields({
      [`maintenance[${index}]['hour']`]: {
        value: duration,
      }
    });

  };

  handleTimeToSelect = (index, e) => {
    const { timeFrom, timeTo } = this.state;
    let { total } = this.state;
    const { form } = this.props;
    timeTo[index] = e;
    const duration = (e && timeFrom[index] && e.diff(timeFrom[index], 'minutes') || 0);
    const val = form.getFieldValue(`maintenance[${index}]['hour']`);
    total = total - ((val && parseInt(val)) || 0);
    total += parseInt(duration);
    this.setState({ timeTo, total });

    form.setFields({
      [`maintenance[${index}]['hour']`]: {
        value: duration,
      }
    });
  };

  getJobCardsByLocation = (e) => {
    const { form } = this.props;
    form.resetFields('maintenance');
    const { jobCardStatus, keys } = this.state;
    this.setState({
      jobCardStatus: {},
      keys: keys.slice(0, 1),
      total: 0,
      timeFrom: [null],
      timeTo: [null],
      showJobsCardNumber: [false],
    }, () => {
      this.props.getJobCardByLocation(e);
    });
  };

  formItems() {
    const { data, form, filters, jobCards, title, loading } = this.props;
    const { getFieldDecorator } = form;
    const { keys, jobCardStatus } = this.state;

    // Selectable activities must be Open in activity status; the backend
    // (findActivitiesByLocation) already restricts these to activities whose Job Card
    // is also Open, so together this enforces "Open activity + Open job card".
    const openJobCardActivities = jobCards.filter(item => item.status === 'Open');

    return keys.map((k, index) => {
      const locked = this.isLockedRow(k, index);
      const isJobCardRow = !!(this.state.showJobsCardNumber && this.state.showJobsCardNumber[index]);
      const hourVal = Number(form.getFieldValue(`maintenance[${index}]['hour']`)) || 0;
      const dHours = Math.floor(hourVal / 60);
      const dMins = hourVal % 60;

      return (
        <div
          key={index}
          className={`mp-entry ${isJobCardRow ? 'mp-entry--jobcard' : 'mp-entry--general'}${locked ? ' mp-entry--locked' : ''}`}
        >
          <div className="mp-entry-top">
            <Form.Item className="mp-fi mp-type">
              {getFieldDecorator(`maintenance[${index}]['type']`, {
                rules: [{ required: true, message: `type is required!` }],
                initialValue: k && k.type && k.type._id
              })(<Select
                showSearch
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                loading={loading}
                style={{ width: '100%' }}
                placeholder="Task type"
                onSelect={this.handleSelect.bind(this, index)}
                // Editable on EDIT except for saved Job-Card rows that already have an activity linked.
                disabled={this.props.title === 'EDIT' ? this.isLockedRow(k, index) : (this.props.disableMaintenanceListByJobCard && this.props.disableMaintenanceListByJobCard[index] && this.props.disableMaintenanceListByJobCard[index] === 'Closed')}
              >
                {filters['maintenance'] && filters['maintenance']['schema'] && filters['maintenance']['schema']['type'].data.data.map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
            </Form.Item>

            {/* Job Card sub-fields — visible only when the task type is Job Card */}
            <div className={`mp-jc-block${isJobCardRow ? '' : ' mp-hidden'}`}>
              <span className="mp-jc-lbl">Activity</span>
              <Form.Item className="mp-fi mp-jc-no">
                {getFieldDecorator(`maintenance[${index}]['jobCardActivityNumber']`, {
                  rules: [{ required: false, message: `Job Card Activity No is required!` }],
                  initialValue: k && k.jobCardActivityNumber && k.jobCardActivityNumber._id
                })(
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Activity no."
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    // Locked for saved Job-Card rows with a linked activity; disabled for non-Job-Card rows.
                    disabled={this.isLockedRow(k, index) || (this.state && this.state.showJobsCardNumber
                      && !this.state.showJobsCardNumber[index])}
                    onSelect={this.handleJobCardSelect.bind(this, index)}
                  >
                    {
                      title === 'EDIT' && k && k.jobCardActivityNumber && k.jobCardActivityNumber._id &&
                      <Select.Option key={k && k.jobCardActivityNumber && k.jobCardActivityNumber._id}
                        value={k && k.jobCardActivityNumber && k.jobCardActivityNumber._id}>
                        {k && k.jobCardActivityNumber && k.jobCardActivityNumber.activitySerialNo}
                      </Select.Option>}
                    {
                      openJobCardActivities && openJobCardActivities.map(item =>
                        <Select.Option key={item._id} value={item._id}>{item.activitySerialNo}</Select.Option>)}
                  </Select>
                )}
              </Form.Item>
              <Form.Item className="mp-fi mp-jc-status">
                {getFieldDecorator(`maintenance[${index}]['activityStatus']`, {
                  rules: [{ required: false, message: `activityStatus is required!` }],
                  initialValue: k && k.activityStatus ? k.activityStatus : jobCardStatus[index]
                })(
                  <Select
                    style={{ width: '100%' }}
                    placeholder="Status"
                    loading={loading}
                    // Locked for saved Job-Card rows with a linked activity; disabled for non-Job-Card rows.
                    disabled={this.isLockedRow(k, index)
                      || (this.state && this.state.showJobsCardNumber && !this.state.showJobsCardNumber[index])
                    }
                  >
                    {filters['maintenance'] && filters['maintenance']['schema'] && filters['maintenance']['schema']['activityStatus'] && filters['maintenance']['schema']['activityStatus'].options.enum.map(item =>
                      <Select.Option key={item} value={item}>{item}</Select.Option>)}
                  </Select>
                )}
              </Form.Item>
            </div>

            <span className="mp-grow" />

            <span className="mp-dur" title="Duration"><b>{dHours}</b><i>h</i> <b>{dMins}</b><i>m</i></span>

            {/* Hidden hour field — value is computed from Time From/To */}
            <Form.Item className="mp-fi mp-hidden">
              {getFieldDecorator(`maintenance[${index}]['hour']`, {
                rules: [{ required: false, message: `Hour is required!` }],
                initialValue: k && k.hour
              })(<Input placeholder={'hour'} disabled={true} style={{ display: 'none' }} />)}
            </Form.Item>

            {locked ? (
              <span className="mp-lockchip" title="Linked to a closed job card — read only">🔒 Closed</span>
            ) : (
              <Icon
                className="mp-remove"
                type="minus-circle-o"
                onClick={() => this.removeMaintenance(index)}
                title="Remove task"
              />
            )}
          </div>

          <div className="mp-entry-bottom">
            <div className="mp-field mp-work">
              <span className="mp-mini-lbl">Work details</span>
              <Form.Item className="mp-fi">
                {getFieldDecorator(`maintenance[${index}]['workDetails']`, {
                  rules: [{ required: false, message: `Work Details is required!` }],
                  initialValue: k && k.workDetails,
                })(<Input disabled={this.isLockedRow(k, index)} placeholder={'What was done'} style={{ width: '100%' }} />)}
              </Form.Item>
            </div>
            <div className="mp-field">
              <span className="mp-mini-lbl">Time from</span>
              <Form.Item className="mp-fi">
                {getFieldDecorator(`maintenance[${index}]['timeFrom']`, {
                  rules: [{ required: false, message: `Time From is required!` }],
                  initialValue: k && k.timeFrom && moment(k.timeFrom),
                })(<TimePicker disabled={this.isLockedRow(k, index)} onChange={this.handleTimeFromSelect.bind(this, index)} style={{ width: '100%' }} use12Hours format="h:mm a" />)}
              </Form.Item>
            </div>
            <div className="mp-field">
              <span className="mp-mini-lbl">Time to</span>
              <Form.Item className="mp-fi">
                {getFieldDecorator(`maintenance[${index}]['timeTo']`, {
                  rules: [{ required: false, message: `To From is required!` }],
                  initialValue: k && k.timeTo && moment(k.timeTo),
                })(<TimePicker disabled={this.isLockedRow(k, index)} onChange={this.handleTimeToSelect.bind(this, index)} style={{ width: '100%' }} use12Hours format="h:mm a" />)}
              </Form.Item>
            </div>
          </div>
        </div>
      );
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form, subDocumentFilters } = this.props;
    const { total, allowEntryOfManpowerWithoutMinimumTimeLimitCompleted } = this.state;
    const hours = Math.floor(total / 60);
    const mins = total % 60;
    const requiredMinutes = this.getRequiredWorkMinutes(form.getFieldValue('employee'));
    // A finite, positive requirement means an employee (with a minimum) is resolved.
    // Before that, requiredMinutes can be Infinity (MAX_VALUE fallback) — don't render it.
    const hasRequirement = isFinite(requiredMinutes) && requiredMinutes > 0;
    const reqHours = hasRequirement ? Math.floor(requiredMinutes / 60) : 0;
    const reqMins = hasRequirement ? requiredMinutes % 60 : 0;
    const meetsMinimum = allowEntryOfManpowerWithoutMinimumTimeLimitCompleted || (hasRequirement && total >= requiredMinutes);
    const shortMinutes = hasRequirement ? Math.max(0, requiredMinutes - total) : 0;
    const progressPct = hasRequirement ? Math.min(100, Math.round((total / requiredMinutes) * 100)) : 0;
    const maintenanceCount = (this.state.keys && this.state.keys.length) || 0;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical" className="mp-form">

            <div className="mp-section">
              <div className="mp-section-head"><span className="mp-step">1</span><h2>Entry details</h2></div>
              <div className="mp-section-body mp-grid3">

            <Form.Item key={`employee`} label={'Employee'}>
              {getFieldDecorator(`employee`, {
                rules: [{ required: true, message: `Employee is required!` }],
                initialValue: data && data.employee && data.employee._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                onSelect={this.handleEmployeeSelect.bind(this)}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {filters['employee'] && filters['employee']['data'] && filters['employee']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['employee'] && filters['employee'].options && filters['employee'].options.master ?
                  <MasterModal resource={resource} item={filters['employee'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>


            {/*<Form.Item key={'employeeCode'} label={'Employee Code'}>*/}
            {/*  {getFieldDecorator('employeeCode', {*/}
            {/*    rules: [{ required: true, message: `Employee Code is required!` }],*/}
            {/*    initialValue: data && data.employeeCode,*/}
            {/*  })(<Input />)*/}
            {/*  }*/}
            {/*</Form.Item>*/}

            <Form.Item key={'date'} label={'Date'}>
              {getFieldDecorator('date', {
                rules: [{ required: true, message: `Date is required!` }],
                initialValue: data && data.date && moment(data.date),
              })(<DatePicker />)
              }
            </Form.Item>

            <Form.Item key={'location'} label={'Location'}>
              {getFieldDecorator('location', {
                rules: [{ required: true, message: `Location is required!` }],
                initialValue: data && data.location && data.location._id,
              })(<Select
                showSearch
                style={{ width: '80%' }}
                onSelect={this.getJobCardsByLocation}
                placeholder="Select Location"
                disabled={title === 'EDIT'}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {filters['location'] && filters['location']['data'] && filters['location']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['location'] && filters['location'].options && filters['location'].options.master ?
                  <MasterModal resource={resource} item={filters['location'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

              </div>
            </div>

            <div className="mp-section">
              <div className="mp-section-head">
                <span className="mp-step">2</span>
                <h2>Maintenance log</h2>
                <span className="mp-count">{maintenanceCount} {maintenanceCount === 1 ? 'task' : 'tasks'}</span>
                {(title === 'CREATE' || title === 'EDIT') && (
                  <button type="button" className="mp-add-btn" onClick={this.addMaintenance}>
                    <Icon type="plus" /> Add task
                  </button>
                )}
              </div>
              <div className="mp-entries">
                {this.formItems()}
              </div>

              <div className={`mp-meter${!hasRequirement ? '' : (meetsMinimum ? ' mp-meter--ok' : ' mp-meter--short')}`}>
                <div className="mp-meter-row">
                  <div className="mp-meter-total">
                    {hours}h {mins}m
                    {hasRequirement && <span className="mp-meter-of"> / {reqHours}h {reqMins}m required</span>}
                  </div>
                  <div className="mp-meter-actions">
                    {(title === 'CREATE' || title === 'EDIT') && (
                      <button type="button" className="mp-add-btn mp-add-btn--meter" onClick={this.addMaintenance}>
                        <Icon type="plus" /> Add task
                      </button>
                    )}
                    <span className="mp-meter-status">
                      {!hasRequirement
                        ? 'Select an employee to set the daily minimum'
                        : meetsMinimum
                          ? '✓ Minimum met'
                          : `⚠ ${Math.floor(shortMinutes / 60)}h ${shortMinutes % 60}m short of minimum`}
                    </span>
                  </div>
                </div>
                <div className="mp-track"><div className="mp-fill" style={{ width: `${progressPct}%` }} /></div>
              </div>
            </div>

            <div className="mp-section">
              <div className="mp-section-head"><span className="mp-step">3</span><h2>Sign-off</h2></div>
              <div className="mp-section-body mp-grid2">

            <Form.Item key={'preparedBy'} label={'Prepared By Name'}>
              {getFieldDecorator('preparedBy', {
                rules: [{ required: true, message: `Prepared By Name is required!` }],
                initialValue: (data && data.preparedBy && data.preparedBy._id) || (title === 'CREATE' ? this.getLoggedInManpowerId() : undefined),
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['preparedBy'] && filters['preparedBy'].options.disabledOnEdit) || false}
              >
                {filters['preparedBy'] && filters['preparedBy']['data'] && filters['preparedBy']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['preparedBy'] && filters['preparedBy'].options && filters['preparedBy'].options.master ?
                  <MasterModal resource={resource} item={filters['preparedBy'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

            <Form.Item key={'preparedDate'} label={'Prepared Date'}>
              {getFieldDecorator('preparedDate', {
                rules: [{ required: true, message: `Prepared Date is required!` }],
                initialValue: (data && data.preparedDate && moment(data.preparedDate)) || (title === 'CREATE' ? moment() : undefined),
              })(<DatePicker />)
              }
            </Form.Item>

            <Form.Item key={'receivedBy'} label={'Received By Name'}>
              {getFieldDecorator('receivedBy', {
                rules: [{ required: true, message: `Received By Name is required!` }],
                initialValue: (data && data.receivedBy && data.receivedBy._id) || (title === 'CREATE' ? this.getLoggedInManpowerId() : undefined),
              })(<Select
                showSearch
                style={{ width: '80%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                }
                disabled={(title === 'EDIT' && filters['receivedBy'] && filters['receivedBy'].options.disabledOnEdit) || false}
              >
                {filters['receivedBy'] && filters['receivedBy']['data'] && filters['receivedBy']['data']['data'].map(item =>
                  <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
              </Select>)}
              {
                filters['receivedBy'] && filters['receivedBy'].options && filters['receivedBy'].options.master ?
                  <MasterModal resource={resource} item={filters['receivedBy'].options.ref} title={'CREATE'} /> : ''
              }
            </Form.Item>

            <Form.Item key={'receivedDate'} label={'Received Date'}>
              {getFieldDecorator('receivedDate', {
                rules: [{ required: true, message: `Received Date is required!` }],
                initialValue: (data && data.receivedDate && moment(data.receivedDate)) || (title === 'CREATE' ? moment() : undefined),
              })(<DatePicker />)
              }
            </Form.Item>

              </div>
            </div>

            {
              Object.keys(filters).map((item) => {
                if (item === 'documents' && filters[item].type === 'Array')
                  return <div className="mp-section" key={item}>
                    <div className="mp-section-head"><span className="mp-step">4</span><h2>Documents</h2></div>
                    <div className="mp-section-body">
                      <DocumentList match={this.props.match} history={this.props.history}
                        item={filters[item]} form={form} data={data[item]}
                        subDocumentFilters={subDocumentFilters}
                        getDocumentData={this.getDocumentData} />
                    </div>
                  </div>
              })
            }

            <div className="mp-actionbar">
              <div className="mp-ab-total">
                <span className="mp-ab-k">Total logged</span>
                <span className="mp-ab-v">{hours}h {mins}m
                  {hasRequirement && !meetsMinimum && <span className="mp-ab-warn"> · {Math.floor(shortMinutes / 60)}h {shortMinutes % 60}m under min</span>}
                </span>
              </div>
              <span className="mp-ab-spacer" />
              {hasRequirement && !meetsMinimum && <span className="mp-ab-note">Reach {reqHours}h {reqMins}m to enable {title === 'EDIT' ? 'update' : 'create'}</span>}
              {(this.props.title === 'CREATE' || this.props.title === 'EDIT') && (
                <Button type="primary"
                  disabled={allowEntryOfManpowerWithoutMinimumTimeLimitCompleted ? false : (this.getRequiredWorkMinutes(form.getFieldValue('employee')) > this.getTotalWorkMinutes())}
                  className="gx-mb-0 mp-submit" htmlType="submit" loading={loading}>
                  {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>
              )}
            </div>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
